<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card flat  elevation="20">
        <v-card-title primary-title>
            <h4>Регистрация нового создателя ботов!</h4>
        </v-card-title>
        <v-card-text>
            <v-text-field prepend-icon="email" label="Электронная почта" v-model="userModel.email"
                          required autofocus
            ></v-text-field>
<!--            <v-text-field prepend-icon="vpn_key" label="Код для регистрации (можно получить у Администраторов)" v-model="code"
                          required autofocus></v-text-field>-->
            <v-text-field prepend-icon="title" label="Имя" type="text"
                          v-model="userModel.first_name" required></v-text-field>
            <v-text-field prepend-icon="lock" label="Пароль" type="password"
                          v-model="userModel.password" required></v-text-field>
            <v-text-field prepend-icon="lock" label="Подтверждение пароля" type="password"
                          v-model="userModel.passwordConfirm" required></v-text-field>
        </v-card-text>
        <v-card-actions>
            <v-row>
                <v-col cols="12" xs12>
                    <v-card class="d-flex justify-center" flat>
                        <v-btn color="primary" large block @click="handleSubmit" text>Зарегистрироваться</v-btn> <!--:disabled="+code !== verification"-->
                    </v-card>
                </v-col>
                <!--<v-col cols="12" xs12 px-4>
                    <v-card class="d-flex justify-center" flat>
                        <v-menu
                                v-model="showWidgetVK"
                                :close-on-content-click="true"
                                offset-x
                                width="250"
                                min-width="250"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn color="primary" large block text v-on="on" :disabled="+code !== verification">Зарегистрироваться с помощью ВК</v-btn>
                            </template>
                            <v-card width="250" class="ma-0" style="width: 250px">
                                <v-card-text width="250">
                                    <div id="vk_auth"></div>
                                </v-card-text>
                            </v-card>
                        </v-menu>
                    </v-card>
                </v-col>-->
            </v-row>
        </v-card-actions>
        <v-snackbar
                v-model="snackbar"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-card>
</template>

<script>
import axios from 'axios'
import constConf from '../../constconf'
import { injectVKOpenApi, initVK } from '../../scripts/api/vk.js'
export default {
    name: 'SignUpForm',
    data() {
        return {
            userModel: {
                email: '',
                username: '',
                first_name: '',
                password: '',
                passwordConfirm: ''
            },
            paramsSnackbar: {
                color: 'success',
                text: 'Успешно сохранено!'
            },
            snackbar: false,
            showWidgetVK: false,
            widgetVKLoaded: false,
            code: '',
            verification: null
        }
    },
    methods: {
        handleSubmit(e) {
            e.preventDefault()
            if (this.userModel.password.length > 0 && this.userModel.passwordConfirm === this.userModel.password) {
                axios.defaults.withCredentials = true
                axios.post(constConf.user.url + '/user/signup', this.userModel)
                    .then(response => {
                        if (!response.data.hasOwnProperty('error')) {
                            this.setcookie('user', 'login', 1)
                            this.$router.push('bot')
                            this.$store.dispatch('user/loadUserByModel', response.data)
                        } else {
                            this.paramsSnackbar.color = 'error'
                            this.paramsSnackbar.text = response.data.error.text // 'Не правильно введен пароль, повторите ввод'
                            this.snackbar = true
                        }
                    })
                    .catch(function (error) {
                        console.error(error.response)
                    })
            }
        },
        setcookie(cookieName, attribute, addDays) {
            if (addDays) {
                var date = new Date()
                date.setDate(date.getDate() + addDays)
            }
            if (cookieName && attribute) {
                document.cookie = cookieName + '=' + attribute + (addDays ? '; expires=' + date.toUTCString() : '')
            } else { return false }
        }
    },
    watch: {
        showWidgetVK() {
            if (this.showWidgetVK === true && !this.widgetVKLoaded) {
                const { width, onAuth, authUrl } = this
                const options = {
                    width,
                    onAuth,
                    authUrl
                }
                console.log('load widget')
                injectVKOpenApi()
                    .then(initVK(true))
                    .then(() => {
                        VK.Widgets.Auth('vk_auth', options)
                    })
                this.widgetVKLoaded = true
            }
        }
    },
    props: {
        /*
             * sets module width in pixels (integer > 300)
             */
        width: {
            type: Number,
            validator: value => !value || value > 300
        },
        /*
             * sets action done during authorization
             * (by default it is navigation to the specified URL with necessary parameters)
             */
        onAuth: {
            type: Function
        },
        authUrl: {
            type: String
        }
    },
    created() {
        this.verification = (Math.floor(new Date().getTime() / 1000000.0)) * 1000 + 123
    }
}
</script>

<style scoped>

</style>
